// Import slim-select CSS styles.
import 'slim-select/styles' // eslint-disable-line import-x/no-unassigned-import

import { Controller } from '@hotwired/stimulus'
import SlimSelect from 'slim-select'

// Connects to data-controller="slim-select"
export default class extends Controller {
  connect (): void {
    // eslint-disable-next-line no-new
    new SlimSelect({
      select: this.element,
    })
  }
}
